import { render, staticRenderFns } from "./ClientNotificationsSetting.vue?vue&type=template&id=76c8b808&scoped=true"
import script from "./ClientNotificationsSetting.vue?vue&type=script&lang=js"
export * from "./ClientNotificationsSetting.vue?vue&type=script&lang=js"
import style0 from "./ClientNotificationsSetting.vue?vue&type=style&index=0&id=76c8b808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c8b808",
  null
  
)

export default component.exports